class CourseBooking extends HTMLElement {
  constructor() {
    super();
    this.validPostCode = false;
  }

  connectedCallback() {
    this.courseBooking = document.querySelector('course-booking');
    this.waitlistContainer = this.querySelector('[data-waitlist-form]');
    this.waitlistSuccessContainer = this.querySelector('[data-waitlist-success]');
    this.waitlistSubmit = this.querySelector('[data-waitlist-submit]');
    this.selectContainer = this.querySelector('[data-waitlist-products]')
    this.postCodeSelector = this.querySelector('[data-waitlist-postcode]');
    this.suburbSelector = this.querySelector('[data-waitlist-suburb]');
    this.quantitySelector = this.querySelector('[data-waitlist-quantity]');
    this.calendarPickerSelector = this.querySelector('[data-calendar-picker]');
    this.courseFormSelector = this.querySelector('[data-course-form]');
    this.postcodeInput = this.querySelector('[data-post-code]');
    this.timeValue = this.querySelector('[data-time]');
    this.dateTimeSlot = this.querySelector('[data-date-time-slot]')
    this.quantityVariant = this.querySelector('[data-variant-quantity]')

    this.currentVariantInput = this.querySelector('input[name="id"]')
    this.productId = this.querySelector('input[name="pid"]')
    this.currentVariantTitle = this.querySelector('[data-variant-title]')

    this.errorMessage = this.querySelector('[data-zone-error]');
    this.suburb = this.querySelector('[data-suburb]');
    this.suburbSelect = this.querySelector('[data-suburb-select]')

    this.zoneTitleInput = this.querySelector('[data-zone-variant-title]')
    this.zoneIdInput = this.querySelector('[data-zone-variant-id]')

    this.quantitySelectorPlus = this.querySelector('[data-course-quantity-plus]');
    this.quantitySelectorMinus = this.querySelector('[data-course-quantity-minus]');

    if (this.waitlistContainer) {
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitWaitlist.bind(this));
    }

    this.getProductId();
    this.setActiveProductId();

    if (this.postcodeInput) {
      this.postcodeInput.addEventListener('input', this.handlePostcodeInput.bind(this));
    }

    this.reschedule = this.querySelector('[data-reschedule]')
    this.formReschedule = this.querySelector('[data-reschedule-form]');
    this.bookingIdSelector = this.querySelector('[data-booking-id]')
    this.bookingNewDateSelector = this.querySelector('[data-booking-new-date]')
    this.rescheduleTitle = this.querySelector('[data-booking-title]')
    this.rescheduleEmail = this.querySelector('[data-booking-email]')
    this.rescheduleBookedAt = this.querySelector('[data-booking-booked-at]')
    this.rescheduleName = this.querySelector('[data-booking-name]')
   
    if(this.reschedule) {
      this.rescheduleForm()
    }
  }

  getHeaders() {
    return {
      'Content-Type': 'application/graphql',
      'X-Shopify-Storefront-Access-Token': 'cbfc50502573d236f8ece526ce8c8adb'
    };
  }

  setActiveProductId() {
    const urlParams = new URLSearchParams(window.location.search);
    const courseProductId = Number(urlParams.get('productId'));
    const courseType = urlParams.get('productCourse');

    this.optgroupLabel = courseType

    if (courseProductId) {
      const options = Array.from(this.selectContainer.options);

      const matchingOption = options.find(option => Number(option.getAttribute('data-course-product-id')) === courseProductId);

      if (matchingOption) {
        matchingOption.selected = true;
      }

      this.handleFieldInput(courseType)
      this.fetchStorefrontProduct(courseProductId, courseType);
      this.fetchTimes(courseProductId);

      if (this.courseBooking) {
        this.courseBooking.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }

  handleFieldInput(courseType) {
    if (courseType === 'Private') {
      this.postCodeSelector.classList.remove('hide')
      this.suburbSelector.classList.remove('hide')
      this.quantitySelector.classList.add('hide')

      const input = this.postCodeSelector.querySelector('input')
      input.removeAttribute('disabled')

      this.waitlistContainer.classList.add('private-course')
      this.waitlistContainer.classList.remove('public-course')
      this.courseFormSelector.classList.add('private')
      this.courseFormSelector.classList.remove('public')
      
    } else {
      
      this.postCodeSelector.classList.add('hide')
      this.suburbSelector.classList.add('hide')
      this.quantitySelector.classList.remove('hide')

      this.calendarPickerSelector.removeAttribute('disabled')

      this.quantitySelectorPlus.removeAttribute('disabled')
      this.quantitySelectorMinus.removeAttribute('disabled')

      this.waitlistContainer.classList.remove('private-course')
      this.waitlistContainer.classList.add('public-course')

      this.courseFormSelector.classList.remove('private')
      this.courseFormSelector.classList.add('public')
    }
  }

  getProductId() {
    if(this.selectContainer) {
      this.selectContainer.addEventListener('change', (event) => {
        const selectedOption = this.selectContainer.options[this.selectContainer.selectedIndex];
        const optgroup = selectedOption.closest('optgroup');
        this.optgroupLabel = optgroup ? optgroup.label : '';
  
        this.removeAndResetLocalitiesSelector();
        this.handleFieldInput(this.optgroupLabel)

        let courseProductId = selectedOption.getAttribute('data-course-product-id');
        courseProductId = Number(courseProductId);
  
        if (courseProductId) {
          this.fetchStorefrontProduct(courseProductId, this.optgroupLabel);
          this.fetchTimes(courseProductId);
        }
      });
    }
  }

  fetchStorefrontProduct(productId, courseType) {
    const PRODUCT_QUERY = `
      availableForSale
      id
      title
      handle
      tags
      productType
      options {
        name,
        values
      }
      variants(first: 250) {
        edges {
          node {
            id
            availableForSale
            title
            selectedOptions {
              value
              name
            }
          }
        }
      }
      metafield(key: "zone", namespace: "map") {
        value
      }
    `
    
    let graphQuery = `query allProducts @inContext(country: ${Shopify.country}) { 
      product(id: "${btoa(`gid://shopify/Product/${productId}`)}") {
        id
        ${PRODUCT_QUERY}
      }
    }`;
  
    const requestOptions = {
      method: 'POST',
      headers: this.getHeaders(),
      body: graphQuery
    };
  
    return fetch(`https://${Shopify.shop}/api/2024-07/graphql.json`, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(({ data }) => {
        const product = this.transformProductGraphql(data.product)
        const metaobjectId = data.product.metafield

        this.product = product
        this.productVariants = product.variants

        this.productId.value = this.product.id
        this.currentVariantInput.value = this.productVariants[0].id
        this.currentVariantTitle.value = `${this.product.title} - ${this.productVariants[0].options[0]}`

        if (metaobjectId) {
          this.fetchStorefrontMetaobject(metaobjectId.value)
        }

        if(courseType === 'Public') this.handlePublicCourseMaxQuantity(product)
      })
      .catch(error => {
        console.error('Error in fetching storefront products', error);
    });
  }

  fetchStorefrontMetaobject(metaobjectId) {
    const METAOBJECT_QUERY = `
      fields {
        key
        value
        type
      }
    `

    let graphQuery = `query metaobject @inContext(country: ${Shopify.country}) { 
      metaobject(id: "${btoa(metaobjectId)}") {
        id
        ${METAOBJECT_QUERY}
      }
    }`;

    const requestOptions = {
      method: 'POST',
      headers: this.getHeaders(),
      body: graphQuery
    };
  
    return fetch(`https://${Shopify.shop}/api/2024-07/graphql.json`, requestOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(({ data }) => {
        const metaobject = this.transformMetaobjectGraphql(data.metaobject)
        this.allowedPostCodes = metaobject
      })
      .catch(error => {
        console.error('Error in fetching storefront products', error);
    });
  }

  transformProductGraphql(productNode) {
    if (!productNode) {
      return null;
    }
  
    const variants = productNode.variants.edges.map(({ node }) => {
      return {
        id: parseInt(node.id.replace('gid://shopify/ProductVariant/', '')),
        available: node.availableForSale,
        options: node.selectedOptions.map(option => option.value),
        option1: node.selectedOptions[0].value,
        ...node.selectedOptions[1] && {
          option2: node.selectedOptions[1].value,
        },
        ...node.selectedOptions[2] && {
          option3: node.selectedOptions[2].value,
        }
      }
    });
  
    return {
      objectType: 'product',
      id: parseInt(productNode.id.replace('gid://shopify/Product/', '')),
      title: productNode.title,
      metafield: productNode.metafield?.value,
      variants
    };
  }

  transformMetaobjectGraphql(metaobjectNode) {
    if (!metaobjectNode) {
      return null;
    }
    const fields = metaobjectNode.fields.reduce((acc, field) => {
      if (field.key === 'zone_1_postcodes') {
        acc.zone_1 = field.value.split(',').map(Number);
      }
      if (field.key === 'zone_2_postcodes') {
        acc.zone_2 = field.value.split(',').map(Number);
      }
      return acc;
    }, {});
  
    return {
      zone_1: fields.zone_1 || [],
      zone_2: fields.zone_2 || []
    };
  }

  onSubmitWaitlist(evt) {
    evt.preventDefault();

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    if (this.optgroupLabel === 'Public') {
      this.handlePublicCourseVariant()
    }

    const formData = new FormData(this.form);
    config.body = formData;

    setTimeout(() => {
      fetch(`https://tinyhearts-booking.com/api/addwaitlist`, config)
      .then((response) => response.json())
      .then((response) => {
        this.waitlistContainer.classList.add('hide')
        this.waitlistSuccessContainer.classList.remove('hide')
  
        this.courseBooking.scrollIntoView({ behavior: 'smooth' });
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
  
      });
    }, 2000);
  }

  fetchTimes (productId) {
    fetch(`https://tinyhearts-booking.com/api/getInfo?pid=${productId}`)
    .then(response => response.json())
    .then(data => {
      const formData = data.form;
      const bookingData = data.dates;
      this.initializeFlatpickr(bookingData, data.cutoff_days);
      this.initializeTimeSlots(bookingData);
      this.initializeForm(formData);

      this.waitlistSubmit.removeAttribute('disabled')
    });
  }

  initializeForm(formData) {
    let form_html = '';
    formData.map((field, index) => {
      var required = '';
      if (field.required == true) required = 'required';
      switch (field.type) {
        case 'textarea':
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label><textarea rows="4" name='properties[${field.label}]' id="tbe_field_${index}" class="${required}" ${required}></textarea>`;
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        case 'checkbox':
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label>`;
          field.options.split(",").map((option) => {
            form_html += `<label class="option"><input type="${field.type}" name='properties[${field.label}][]' class="${required} tbe_field_${index}" data-cls="tbe_field_${index}" value="${option}" ${required}/> ${option}</label>`;
          })
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        case 'radio':
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label>`;
          field.options.split(",").map((option) => {
            form_html += `<label class="option"><input type="${field.type}" name='properties[${field.label}]' class="${required} tbe_field_${index}" data-cls="tbe_field_${index}" value="${option}" ${required}/> ${option}</label>`;
          })
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        case 'select':
          form_html = form_html + `<div class="element element__select"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          form_html += `</label>`;
          form_html += `<select id="tbe_field_${index}" name='properties[${field.label}]' class="${required}" ${required}>`;
          form_html += `<option value="" selected disabled hidden>${field.label}</option>`;
          field.options.split(",").map((option) => {
            form_html += `<option value="${option}">${option}</option>`;
          })
          form_html += `</select>`;
          form_html += `<svg class="icon-arrow" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 16"><path stroke="#005A60" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m12.5 6-4 4-4-4"/></svg>`;
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
        default:
          form_html = form_html + `<div class="element"><label for="tbe_field_${index}">${field.label}`;
          if (field.required == true) form_html += '<span class="required-mark">*</span>';
          const addedAttr = field.type == "number" ? 'min="1" onwheel="this.blur()"' : '';
          form_html += `</label><input ${addedAttr} type="${field.type}" name='properties[${field.label}]' placeholder='${field.label}' id='tbe_field_${index}' class="${required}" ${required}/>`;
          form_html += `<p class="error-message" style="display: none; color: red">This field is required.</p></div>`;
          break;
      }
    })
    document.querySelector("[data-course-form]").innerHTML = form_html;

    setTimeout(() => {
      const formPostcode = document.querySelector('.element input[name="properties[Postcode]"]')
      if(formPostcode) {
        formPostcode.value = this.postCode
      }
    }, 1000);
  }

  handlePublicCourseMaxQuantity(product) {
    if (product && product.variants && product.variants.length > 0) {

      product.variants.forEach(variant => {
        variant.option1 = Number(variant.option1.replace(/ Person| People/, ''));
      });

      const firstVariant = product.variants[0];
      const lastVariant = product.variants[product.variants.length - 1];
  
      const firstOption = firstVariant.option1;
      const lastOption = lastVariant.option1;

      const input = this.quantitySelector.querySelector('input')
      input.setAttribute('min', firstOption)
      input.setAttribute('max', lastOption)
  
    } else {
      console.error('Invalid product or variants');
    }
  }  

  handlePublicCourseVariant() {
    let quantityValue = this.quantityVariant.getAttribute('data-variant-quantity');

    const learnerVariant = this.productVariants.find(variant => {
      const title = variant.option1
      return title === Number(quantityValue)
    })

    this.currentVariantInput.value = learnerVariant.id
    this.productId.value = this.product.id
    this.currentVariantTitle.value = `${this.product.title} - ${learnerVariant.options[0]}`
  }

  findZone() {
    for (const key in this.allowedPostCodes) {
      if (this.allowedPostCodes[key].includes(Number(this.postCode))) {
        return key
      }
    }

    return null
  }

  handlePostcodeInput(event) {
    this.postCode = event.target.value;

    const formPostcode = document.querySelector('.element input[name="properties[Postcode]"]')

    if(formPostcode) {
      formPostcode.value = this.postCode
    }

    this.postCodeSelector.classList.remove('not-available');

    if (this.postCode.length === 4 && /^\d{4}$/.test(this.postCode)) {
      this.validPostCode = true

      if (!this.isPostcodeAllowed(this.postCode)) {
        this.postCodeSelector.classList.add('not-available');
        this.removeAndResetLocalitiesSelector();

      } else {
        this.validPostCode = true
        this.suburb.classList.remove('is-hidden')

        this.calendarPickerSelector.removeAttribute('disabled')

        this.lookupSuburb(this.postCode);
     
        const zone = this.findZone()

        if (zone) {
          const zoneVariant = this.productVariants.find(variant => {
            const title = variant.option1.toLowerCase().replaceAll(' ', '_')

            return title === zone
          })
          
          this.zoneVariant = zoneVariant

          this.productId.value = this.product.id
          this.currentVariantInput.value = zoneVariant.id
          this.currentVariantTitle.value = `${this.product.title} - ${zoneVariant.option1}`
          this.zoneTitleInput.value = zoneVariant.option1
          this.zoneIdInput.value = zoneVariant.id
        } 
      }
    }
  }

  isPostcodeAllowed(postcode) {
    return Object.values(this.allowedPostCodes).some(zone => zone.includes(parseInt(postcode, 10)));
  }

  lookupSuburb(postcode) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'address': postcode, 'componentRestrictions': {'country': 'AU'} }, (results, status) => {
      if (status === google.maps.GeocoderStatus.OK && results[0]) {
        const postalLocalities = results[0].postcode_localities;
        const suburb = results[0].address_components[1].long_name;
        if (postalLocalities && postalLocalities.length > 1) {
          this.handleMultipleLocalities(postcode, postalLocalities);
        } else {
          this.updatePostcodeField(postcode, suburb);
        }
      } else {
        this.removeAndResetLocalitiesSelector()
      }
    });
  }

  removeAndResetLocalitiesSelector() {
    this.validPostCode = false

    this.suburbSelect.setAttribute('disabled','')

    this.dateTimeSlot.innerHTML = "Choose a time"
    this.calendarPickerSelector.setAttribute('disabled','')

    this.courseFormSelector.classList.add('hide')
    this.postcodeInput.value = ''
    this.zoneTitleInput.value = ''
    this.zoneIdInput.value = ''
  }

  handleMultipleLocalities(postcode, localities) {
    this.updatePostcodeField(postcode, localities[0])

    const inputSuburb = this.suburbSelector.querySelector('select')
    inputSuburb.removeAttribute('disabled')
    
    let options = ''

    localities.forEach(locality => {
      options += `
        <option value="${postcode}, ${locality}">
          ${locality}
        </option>
      `
    });

    this.suburbSelect.innerHTML = options;
    this.suburb.classList.remove('is-hidden')
  }

  updatePostcodeField(postcode, suburb) {
    let options = ''

    options += `
      <option value="${postcode}, ${suburb}">
        ${suburb}
      </option>
    `

    this.suburbSelect.innerHTML = options;
    this.suburb.classList.remove('is-hidden')
  }

  initializeFlatpickr(bookingData, cutoffdays) {
    const today = new Date(); 
    const afterCutoffDays = new Date(today.setDate(today.getDate() + cutoffdays)).toISOString();
    const availableDateTimes = bookingData
        .filter(booking => booking.booked >= booking.capacity && new Date(booking.datetime+"+11:00").toISOString() > afterCutoffDays)
        .map(booking => booking.datetime); 

    const uniqueAvailableDates = [...new Set(availableDateTimes.map(dt => dt.split('T')[0]))];

    flatpickr("#calendarContainer", {
      inline: true,
      dateFormat: "Y-m-d",
      minDate: "today",
      enable: uniqueAvailableDates,
      onChange: (selectedDates) => {
        this.selectedDate = selectedDates[0]; 
        this.updateAvailableTimes(this.selectedDate, bookingData); 
      }
    });
  }

  initializeTimeSlots(bookingData) {
    const uniqueSlots = new Set();

    bookingData.forEach(booking => {
      const time = booking.datetime.split('T')[1].substring(0, 5);
      uniqueSlots.add(time);
    });

    const sortedUniqueSlots = Array.from(uniqueSlots).sort((a, b) => {
      const timeA = this.convertTo24Hour(a);
      const timeB = this.convertTo24Hour(b);
      return timeA - timeB;
    });

    const timeSlotsContainer = document.getElementById('timeSelection');
    timeSlotsContainer.innerHTML = '';

    sortedUniqueSlots.forEach(time => {
      const label = document.createElement('label');
      const radioInput = document.createElement('input');
      const span = document.createElement('span');
      span.appendChild(document.createTextNode(` ${this.formatTime(time)}`));
      radioInput.type = 'radio';
      radioInput.name = 'timeSlot';
      radioInput.value = time;
      radioInput.disabled = true;
      label.appendChild(radioInput);
      label.appendChild(span);
      timeSlotsContainer.appendChild(label);
   
      radioInput.addEventListener('change', () => {
        this.selectedTime = radioInput.value;  
        if (this.selectedDate && this.selectedTime) {
          const selectedDateTime = `${this.selectedDate.toISOString().split('T')[0]}T${this.selectedTime}`;
          const formattedDateTime = `${this.formatDate(this.selectedDate)} — ${this.formatTime(this.selectedTime)}`;

          document.querySelector('[data-date-time-slot]').innerHTML = formattedDateTime;
        }
      });
    });

    this.timeSlotRadios = document.querySelectorAll('input[name="timeSlot"]')

    this.timeSlotRadios.forEach(radio => {
      radio.addEventListener('change', this.validateInputs.bind(this)); 
    });
  }

  validateInputs (display) {
    const hasTimeSlotSelected = Array.from(this.timeSlotRadios).some(input => input.checked);

    const confirmButton = document.querySelector('[data-confirm-button]')

    if (hasTimeSlotSelected) {
      confirmButton.removeAttribute('disabled');
      if(this.courseFormSelector) this.courseFormSelector.classList.remove('hide')
     
    } else {
      confirmButton.setAttribute('disabled', true);
      if(this.courseFormSelector) this.courseFormSelector.classList.add('hide')
    }
  }

  updateAvailableTimes(selectedDate, bookingData) {
    const timeSlotsContainer = document.getElementById('timeSelection');
    const inputs = timeSlotsContainer.querySelectorAll('input[type="radio"]');
    inputs.forEach(input => {
        input.checked = false;
        input.disabled = true;
    });

    if (!selectedDate) return;

    const timezoneOffset = 11; 
    const adjustedDate = new Date(selectedDate.getTime() + timezoneOffset * 3600 * 1000);
    const selectedDateString = adjustedDate.toISOString().split('T')[0];

    const timesForDate = bookingData
      .filter(booking => booking.datetime.startsWith(selectedDateString))
      .map(booking => ({
        time: booking.datetime.split('T')[1].substring(0, 5),
        isAvailable: booking.booked === 0
      }));

    inputs.forEach(input => {
      const isAvailable = timesForDate.some(time => time.time === input.value && time.isAvailable);
      input.disabled = isAvailable;
      input.addEventListener('change', () => {
        if (input.checked) {
          const selectedDateTime = `${selectedDateString}T${input.value}`;
          document.querySelector('[data-datetime-format]').value = selectedDateTime; 
        }
      });
    });

    this.validateInputs(true);
  }

  convertTo24Hour(time) {
    const [hours, minutes] = time.split(':');
    return parseInt(hours) * 100 + parseInt(minutes); 
  }

  formatTime(timeString) {
    const [hours, minutes] = timeString.split(':');
    const hoursInt = parseInt(hours);
    const period = hoursInt >= 12 ? 'PM' : 'AM';
    const formattedHours = ((hoursInt + 11) % 12 + 1); 
    return `${formattedHours}:${minutes} ${period}`;
  }

  getOrdinalSuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1:  return "st";
      case 2:  return "nd";
      case 3:  return "rd";
      default: return "th";
    }
  }
  
  formatDate(date) {
    const day = date.getDate();
    const monthName = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}${this.getOrdinalSuffix(day)}, ${monthName} ${year}`;
  }

  formatBookingAt(bookingAt) {
    const [datePart, timePart] = bookingAt.split(' ');
    const date = new Date(datePart);
    const formattedDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    const formattedTime = this.formatTime(timePart);

    return `${formattedDate} ${formattedTime}`;
  }

  rescheduleForm() {
    if(window.location.hash) {
      var bookingId = parseInt(window.atob(window.location.hash.slice(1)));
      if(bookingId > 0){
        fetch(`https://tinyhearts-booking.com/api/getBooking?id=${bookingId}`)
          .then((response)=> response.json())
          .then((response) => {
            this.existingBookingValue = response
            this.bookingIdSelector.value = response.id;

            const bookingData = response.dates;
            this.rescheduleTitle.textContent = response.booking_name
            this.rescheduleEmail.textContent = response.email

            const formattedBookingAt = this.formatBookingAt(response.booking_at);
            this.rescheduleBookedAt.textContent = formattedBookingAt

            this.initializeRescheduleFlatpickr(bookingData)
            this.initializeRescheduleTimeSlots(bookingData)

            const formReschedule = this.formReschedule;
            const rescheduleButton = document.querySelector('[data-reschedule-submit]')
            const rescheduleSuccessContainer = document.querySelector('[data-reschedule-success]');

            formReschedule.addEventListener("submit", function (e) {
              e.preventDefault();

              rescheduleButton.setAttribute('disabled', true)
              rescheduleButton.textContent = 'Submitting...';

              const body = {
                'booking_id': response.id, 
                'customer_name': formReschedule.customer_name.value, 
                'new_date': formReschedule.new_date.value
              };

              fetch(`https://tinyhearts-booking.com/api/reschedule/submit`, {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(body)
              })
                .then(res => res.json())
                .then((res) => {
                  rescheduleButton.removeAttribute('disabled');
                  rescheduleButton.textContent = 'Submit';

                  reschedule.classList.add('hide')
                  rescheduleSuccessContainer.classList.remove('hide')
                });
            });
          })
      }
    }
  }

  initializeRescheduleFlatpickr(bookingData) {
    const availableDateTimes = bookingData
        .filter(booking => booking.booked < booking.capacity && new Date(booking.datetime+"+11:00").toISOString())
        .map(booking => booking.datetime); 

    const uniqueAvailableDates = [...new Set(availableDateTimes.map(dt => dt.split('T')[0]))];

    flatpickr("#rescheduleCalendar", {
      inline: true,
      dateFormat: "Y-m-d",
      minDate: new Date().fp_incr(1),
      enable: uniqueAvailableDates,
      disable: [
        function(date) {
          const dateString = date.toISOString().split('T')[0];
          return !uniqueAvailableDates.includes(dateString);
        }
      ],
      onChange: (selectedDates) => {
        this.selectedDate = selectedDates[0];  
        this.updateRescheduleAvailableTimes(this.selectedDate, bookingData);
      }
    });
  }

  initializeRescheduleTimeSlots(bookingData) {
    const uniqueSlots = new Set();

    bookingData.forEach(booking => {
      const time = booking.datetime.split('T')[1].substring(0, 5);
      uniqueSlots.add(time);
    });

    const sortedUniqueSlots = Array.from(uniqueSlots).sort((a, b) => {
      const timeA = this.convertTo24Hour(a);
      const timeB = this.convertTo24Hour(b);
      return timeA - timeB;
    });

    const timeSlotsContainer = document.getElementById('rescheduleTimeSelector');
    timeSlotsContainer.innerHTML = '';

    sortedUniqueSlots.forEach(time => {
      const label = document.createElement('label');
      const radioInput = document.createElement('input');
      const span = document.createElement('span');
      span.appendChild(document.createTextNode(` ${this.formatTime(time)}`));
      radioInput.type = 'radio';
      radioInput.name = 'timeRescheduleSlot';
      radioInput.value = time;
      radioInput.disabled = true;
      label.appendChild(radioInput);
      label.appendChild(span);
      timeSlotsContainer.appendChild(label);
    });

    this.timeSlotRadios = document.querySelectorAll('input[name="timeRescheduleSlot"]')

    this.timeSlotRadios.forEach(radio => {
      radio.addEventListener('change', this.validateInputs.bind(this)); 
    });
  }

  updateRescheduleAvailableTimes(selectedDate, bookingData) {
    const timeSlotsContainer = document.getElementById('rescheduleTimeSelector');
    const inputs = timeSlotsContainer.querySelectorAll('input[type="radio"]');
    inputs.forEach(input => {
      input.checked = false
      input.disabled = true
    }); 

    if (!selectedDate) return;

    const timezoneOffset = 10; 
    const adjustedDate = new Date(selectedDate.getTime() + timezoneOffset * 3600 * 1000);
    const selectedDateString = adjustedDate.toISOString().split('T')[0];

    const timesForDate = bookingData
      .filter(booking => booking.datetime.startsWith(selectedDateString))
      .map(booking => ({
        time: booking.datetime.split('T')[1].substring(0, 5),
        isAvailable: booking.booked < booking.capacity
      }));

    inputs.forEach(input => {
      const timeSlotAvailable = timesForDate.find(time => time.time === input.value && time.isAvailable);
      input.disabled = !timeSlotAvailable;
      input.addEventListener('change', () => {
        if (input.checked) {
          const selectedDateTime = `${selectedDateString}T${input.value}`;
          this.bookingNewDateSelector.value = selectedDateTime

          const formattedDateTime = `${this.formatDate(this.selectedDate)} — ${this.formatTime(input.value)}`;
          document.querySelector('[data-date-time-slot]').innerHTML = formattedDateTime;
        }
      });
    });

    this.validateInputs(true);
  }
}

customElements.define('course-booking', CourseBooking);
